import { useEffect } from 'react'
import { BackHandler } from 'utils/history'

export const useBackHandler = goBack => {
  useEffect(() => {
    BackHandler.addEventListener('hardwareBackPress', goBack)

    // Cleanup function
    return () => {
      BackHandler.removeEventListener('hardwareBackPress', goBack)
    }
  }, [goBack])
}
